import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchPosts = createAsyncThunk(
  "posts/fetchPosts",
  async (userId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${apiUrl}/trade/getAllTrades`);
      if (userId !== 0) {
        return res.data.filter((post) => post.user_id !== userId);
      } else {
        return res.data;
      }
    } catch (err) {
      return rejectWithValue("Failed to fetch posts.");
    }
  }
);

export const makePurchase = createAsyncThunk(
  "posts/makePurchase",
  async ({ purchaseData, buyerEmail, userId }, { rejectWithValue }) => {
    const finalAmount =
      purchaseData.amountBuy * 100 * purchaseData.rate * 1.029 + 0.3;
    try {
      const res = await axios.get(
        `${apiUrl}/trade/accept?email=${buyerEmail}&tradeId=${purchaseData.postId}&cardId=${purchaseData.selectedCard.id}&bankAccountId=${purchaseData.selectedAccount.bankAccountId}&userId=${userId}&finalAmount=${finalAmount}`
      );
      return res.data; // you can shape this in reducer if needed
    } catch (err) {
      return rejectWithValue("Network error during purchase.");
    }
  }
);

const postSlice = createSlice({
  name: "posts",
  initialState: {
    posts: [],
    purchase: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.posts = action.payload;
        state.error = null;
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(makePurchase.fulfilled, (state, action) => {
        state.purchase = action.payload;
        state.error = null;
      })
      .addCase(makePurchase.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default postSlice.reducer;
